
import Configuration from './configuration';
import Resources from './resources';
import cookie from 'react-cookies';

class DataServices {
    
    constructor() {
        this.config = new Configuration();
        this.resources = new Resources();
    }
    
    getTokenFromCookie( ){
        var token = cookie.load( this.config.COOKIE_NAME_TOKEN );
        var sessionToken = window.sessionStorage.getItem(this.config.COOKIE_NAME_TOKEN);
        if( !token || !sessionToken ){
            window.location.href='/login';
        }
        return token;
    }
    
    checkTokenFromCookie(){
        return cookie.load( this.config.COOKIE_NAME_TOKEN );
    }
    
    removeTokenCookie( ){
        cookie.remove( this.config.COOKIE_NAME_TOKEN, { path: '/' });
        window.sessionStorage.removeItem(this.config.COOKIE_NAME_TOKEN);
        window.sessionStorage.removeItem(this.config.COOKIE_NAME_USER_DATA);
        window.sessionStorage.removeItem(this.config.COOKIE_NAME_AUTH);
        window.location.href='/login';
    }
    
    async authorize( data , serviceName) {
    //this.resources.BACKEND_SIDE_BASE_URL

         return fetch( this.resources.BACKEND_SIDE_BASE_URL + serviceName, {
                  method: "POST",
                  mode: "cors",
                  headers: {
                             "Content-Type": "application/json",
                              },
                  body: JSON.stringify( data )
                })
                  .then(response => {
                    if (!response.ok) {
                        this.handleResponseError(response);
                    }

                    return response.json();
                  })
                  .catch(error => {
                    this.handleError(error);
                  });
    }
    
    async retrieve(serviceName,serviceAction) {
        return fetch( this.resources.BACKEND_SIDE_BASE_URL +serviceName+ serviceAction , {

          method: "GET",
          mode: "cors",
          headers: {
                "Content-Type": "application/json",
                "Authorization":"Bearer " + this.getTokenFromCookie()
            }
        })
          .then(response => {
            if (!response.ok) {
                this.handleResponseError(response);
            }
            return response.json();
          })
          .then(json => {
            //console.log("Retrieved items:");
            //console.log(json);
            const items = json;
            return items;
          })
          .catch(error => {
            this.handleError(error);
        });
    }
        
    async retrievePOST( data, serviceName ) {
        return fetch( this.resources.BACKEND_SIDE_BASE_URL + serviceName, {
          method: "POST",
          mode: "cors",
          headers: {
                "Content-Type": "application/json",
                "Authorization":"Bearer " + this.getTokenFromCookie()
            },
          body: JSON.stringify( data )
        })
          .then(response => {
            if (!response.ok) {
                this.handleResponseError(response);
            }
           
            return response.json();
          })
          .catch(error => {
            this.handleError(error);
          });
    }
    
    async createItem( newItem, serviceName ) {
        return fetch( this.resources.BACKEND_SIDE_BASE_URL + serviceName, {
          method: "POST",
          mode: "cors",
          headers: {
                "Content-Type": "application/json",
                "Authorization":"Bearer " + this.getTokenFromCookie()
            },
          body: JSON.stringify(newItem)
        })
          .then(response => {
            if (!response.ok) {
                this.handleResponseError(response);
            }
           
            return response.json();
          })
          .catch(error => {
            this.handleError(error);
          });
    }
    
    async getItem( serviceName ) {
        return fetch( this.resources.BACKEND_SIDE_BASE_URL + serviceName, {
          method: "GET",
          mode: "cors",
          headers: {
                "Content-Type": "application/json",
                "Authorization":"Bearer " + this.getTokenFromCookie()
            }
        })
          .then(response => {
            if (!response.ok) {
                this.handleResponseError(response)
            }
            return response.json();
          })
          .then(json => {
//            console.log("Retrieved items:");
//            console.log(json);
            const items = json;
            return items;
          })
          .catch(error => {
            this.handleError(error);
        });
    }
    
    async updateItem( updatedItem, serviceName ) {
        return fetch( this.resources.BACKEND_SIDE_BASE_URL + serviceName, {
          method: "PUT",
          mode: "cors",
          headers: {
                "Content-Type": "application/json",
                "Authorization":"Bearer " + this.getTokenFromCookie()
            },
          body: JSON.stringify(updatedItem)
        })
          .then(response => {
            if (!response.ok) {
                this.handleResponseError(response);
            }
            return response.json();
          })
          .catch(error => {
            this.handleError(error);
          });
    }
    
    async cancelItem( serviceName, serviceAction ) {
        return fetch( this.resources.BACKEND_SIDE_BASE_URL + serviceName + serviceAction, {
            method: "DELETE",
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                "Authorization":"Bearer " + this.getTokenFromCookie()
            },
        })
          .then(response => {
            if (!response.ok) {
                this.handleResponseError(response);
            }
            return response.json();
          })
          .catch(error => {
            this.handleError(error);
          });
    }
    
    handleResponseError(response) {
        if( response.status === 401){
            this.removeTokenCookie( );
        }
        throw new Error("HTTP error, status = " + response.status);
    }
    handleError(error) {
        console.log(error.message);
    }

    getRowPerPage( ){
        var rowPerPage = cookie.load( this.config.COOKIE_NAME_ROW_PER_PAGE );
        if( !rowPerPage ){
            rowPerPage = this.config.DEFAULT_ROW_PER_PAGE;
        }
        return rowPerPage;
    }

    setRowPerPageGrid( rowPerPage ){
        let d = new Date();
        d.setTime( d.getTime() + (1000 * 60 * 60 * 24 * 14) );
        cookie.save(this.config.COOKIE_NAME_ROW_PER_PAGE_GRID, rowPerPage, { path: '/', d, maxAge:(1000 * 60 * 60 * 24 * 14) });
    }

    getRowPerPageGrid( ){
        var rowPerPage = cookie.load( this.config.COOKIE_NAME_ROW_PER_PAGE_GRID );
        if( !rowPerPage ){
            rowPerPage = this.config.DEFAULT_ROW_PER_PAGE_GRID;
        }
        return rowPerPage;
    }

    setRowPerPage( rowPerPage ){
        let d = new Date();
        d.setTime( d.getTime() + (1000 * 60 * 60 * 24 * 14) );
        cookie.save(this.config.COOKIE_NAME_ROW_PER_PAGE, rowPerPage, { path: '/', d, maxAge:(1000 * 60 * 60 * 24 * 14) });
    }
    getTokenforDownload(){
     var token = cookie.load( this.config.COOKIE_NAME_TOKEN );
     return token;
    }

    download( newItem, serviceAction , name) {
        let anchor = document.createElement("a");
        anchor.setAttribute('id', 'tmpLink');
        document.body.appendChild(anchor);
        return fetch( this.resources.BACKEND_SIDE_BASE_URL + serviceAction, {
           method: "POST",
           mode: "cors",
          headers: {
                "Content-Type": "application/json",
                "Authorization":"Bearer " + this.getTokenFromCookie()
            },
          body: JSON.stringify(newItem)
        })
        .then(response => response.blob())
        .then(blobby => {
            let objectUrl = window.URL.createObjectURL(blobby);
            anchor.href = objectUrl;
            anchor.download = name;
            anchor.click();
            window.URL.revokeObjectURL(objectUrl);
        })
        .catch(error => {
            this.handleError(error);
        });
    }

    storeCurrentUserData(userInfo, employeeInfo){
        let currentUser = {
        name:userInfo['name'],
        username:userInfo['username'],
        email:userInfo['email'],
        phone:userInfo['phone'],
        active:userInfo['active'],
        status:userInfo['status'],
        guid:userInfo['guid'],
        roleName:userInfo['roleName'],
        roleGUID:userInfo['roleGUID'],
        facialGUID:userInfo['facialGUID'],
        organizationName:userInfo['organizationName'],
        organizationGUID:userInfo['organizationGUID'],
        createdOn:userInfo['createdOn'],
        updatedOn:userInfo['updatedOn'],

        firstName:employeeInfo? employeeInfo['firstName']: null,
        middleName:employeeInfo? employeeInfo['middleName']: null,
        lastName:employeeInfo? employeeInfo['lastName']: null,
        employeeGUID:employeeInfo? employeeInfo['guid']: null

        };
        window.sessionStorage.setItem(this.config.COOKIE_NAME_USER_DATA, JSON.stringify(currentUser));
    }

    /**
    Sample usage
    var userData = this.dataService.getCurrentUserData();
    var name = userData['name']
    var username = userData['username']
    var facialGUID = userData['facialGUID']
    var organizationGUID = userData['organizationGUID']
    var employeeGUID = userData['employeeGUID']
    var userGUID = userData['guid']
    */
    getCurrentUserData( ){
        var sessionData = window.sessionStorage.getItem(this.config.COOKIE_NAME_USER_DATA);
        if( !sessionData ){window.location.href='/login';}
        return JSON.parse(sessionData);
    }


    /**
    Sample usage
    var auth = this.dataService.getAuthoritiesData( );
    if( auth.includes('ORGANIZATION_READ') ){
        console.log('Hello, I have this privilege');
    }
    */
    getAuthoritiesData( ){
        var sessionData = window.sessionStorage.getItem(this.config.COOKIE_NAME_AUTH);
        if( !sessionData ){window.location.href='/login';}
        return sessionData;
    }

    async retrievePUT( data, serviceName ) {
        return fetch( this.resources.BACKEND_SIDE_BASE_URL + serviceName, {
          method: "PUT",
          mode: "cors",
          headers: {
                "Content-Type": "application/json",
                "Authorization":"Bearer " + this.getTokenFromCookie()
            },
          body: JSON.stringify( data )
        })
          .then(response => {
            if (!response.ok) {
                this.handleResponseError(response);
            }

            return response.json();
          })
          .catch(error => {
            this.handleError(error);
          });
    }

    async retrieveDELETE( serviceName, serviceAction) {
        return fetch( this.resources.BACKEND_SIDE_BASE_URL + serviceName + serviceAction , {
          method: "DELETE",
          mode: "cors",
          headers: {
                "Content-Type": "application/json",
                "Authorization":"Bearer " + this.getTokenFromCookie()
            }
        })
          .then(response => {
            if (!response.ok) {
                this.handleResponseError(response);
            }
            return response.json();
          })
          .then(json => {
            const items = json;
            return items;
          })
          .catch(error => {
            this.handleError(error);
        });
    }

    getAdminDashboardHeadCountOption( ){
        var optionName = cookie.load( this.config.COOKIE_NAME_ADMIN_DASHBOARD_HEADCOUNT_OPTION );
        if( !optionName ){
            optionName = 'week';
        }
        return optionName;
    }

    setAdminDashboardHeadCountOption( optionName ){
        let d = new Date();
        d.setTime( d.getTime() + (1000 * 60 * 60 * 24 * 14) );
        cookie.save(this.config.COOKIE_NAME_ADMIN_DASHBOARD_HEADCOUNT_OPTION, optionName, { path: '/', d, maxAge:(1000 * 60 * 60 * 24 * 14) });
    }

    downloadByGet( serviceAction , name) {
        let anchor = document.createElement("a");
        anchor.setAttribute('id', 'tmpLink');
        document.body.appendChild(anchor);
        return fetch( this.resources.BACKEND_SIDE_BASE_URL + serviceAction, {
           method: "GET",
           mode: "cors",
          headers: {
                "Content-Type": "application/json",
                "Authorization":"Bearer " + this.getTokenFromCookie()
            }
        })
        .then(response => response.blob())
        .then(blobby => {
            let objectUrl = window.URL.createObjectURL(blobby);
            anchor.href = objectUrl;
            anchor.download = name;
            anchor.click();
            window.URL.revokeObjectURL(objectUrl);
        })
        .catch(error => {
            this.handleError(error);
        });
    }

    async retrieveWithoutToken(serviceName,serviceAction) {
        return fetch( this.resources.BACKEND_SIDE_BASE_URL +serviceName+ serviceAction , {

          method: "GET",
          mode: "cors"
        })
          .then(response => {
            if (!response.ok) {
                this.handleResponseError(response);
            }
            return response.json();
          })
          .then(json => {
            //console.log("Retrieved items:");
            //console.log(json);
            const items = json;
            return items;
          })
          .catch(error => {
            this.handleError(error);
        });
    }

    getDeviceTokenFromCookie( ){
        var token = cookie.load( this.config.COOKIE_NAME_DEVICE_TOKEN );
        var sessionToken = window.sessionStorage.getItem(this.config.COOKIE_NAME_DEVICE_TOKEN);
        if( !token || !sessionToken ){
            window.location.href='/sign-up';
        }
        return token;
    }

    async retrievePOSTForRegister( data, serviceName ) {
        return fetch( this.resources.BACKEND_SIDE_BASE_URL + serviceName, {
          method: "POST",
          mode: "cors",
          headers: {
                "Content-Type": "application/json",
                "Authorization":"Bearer " + this.getDeviceTokenFromCookie()
            },
          body: JSON.stringify( data )
        })
          .then(response => {
            if (!response.ok) {
                this.handleResponseError(response);
            }

            return response.json();
          })
          .catch(error => {
            this.handleError(error);
          });
    }

    async retrievePOSTWithoutToken( data, serviceName ) {
        return fetch( this.resources.BACKEND_SIDE_BASE_URL + serviceName, {
          method: "POST",
          mode: "cors",
          headers: {
                "Content-Type": "application/json"
            },
          body: JSON.stringify( data )
        })
          .then(response => {
            if (!response.ok) {
                this.handleResponseError(response);
            }

            return response.json();
          })
          .catch(error => {
            this.handleError(error);
          });
    }

    removeUserData( ){
        cookie.remove( this.config.COOKIE_NAME_TOKEN, { path: '/' });
        window.sessionStorage.removeItem(this.config.COOKIE_NAME_TOKEN);
        window.sessionStorage.removeItem(this.config.COOKIE_NAME_USER_DATA);
        window.sessionStorage.removeItem(this.config.COOKIE_NAME_AUTH);
    }

    getLanguage( ){
        var lang = cookie.load( this.config.COOKIE_NAME_LANGUAGE );
        if( !lang ){
            lang = 'en';
        }
        return lang;
    }

    setLanguage( lang ){
        let d = new Date();
        d.setTime( d.getTime() + (1000 * 60 * 60 * 24 * 14) );
        cookie.save(this.config.COOKIE_NAME_LANGUAGE, lang, { path: '/', d, maxAge:(1000 * 60 * 60 * 24 * 14) });
    }
}
export default DataServices;